var _g, _g2, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path2, _path3, _path4, _path5, _g3, _g4, _g5, _g6, _g7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectiveHealthyCooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 150,
    viewBox: "0 0 286 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10819_8344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.483 128.015C197.521 126.474 214.136 107.36 212.595 85.322C211.054 63.2845 191.94 46.6687 169.903 48.2097C147.865 49.7508 131.249 68.865 132.79 90.9026C134.331 112.94 153.446 129.556 175.483 128.015Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.883 77.2295L191.785 74.4392L193.61 100.529C193.728 102.225 192.45 103.695 190.755 103.813L156.991 106.174C155.296 106.293 153.826 105.015 153.707 103.32L151.883 77.2295Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.678 72.9047L151.775 75.695C151.775 75.695 160.386 70.4662 171.404 69.6957C182.423 68.9252 191.678 72.9047 191.678 72.9047Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.429 83.6476L192 77.5088L196.604 77.1868C197.452 77.1276 198.187 77.7666 198.246 78.6142C198.305 79.4618 197.666 80.197 196.819 80.2563L195.284 80.3636L192.429 83.6476Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.527 86.4377L152.098 80.2988L147.494 80.6208C146.646 80.6801 146.007 81.4152 146.066 82.2628C146.125 83.1104 146.861 83.7495 147.708 83.6902L149.243 83.5829L152.527 86.4377Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.298,
    cy: 68.1605,
    r: 3.07692,
    transform: "rotate(-4 171.298 68.1605)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.971 105.183C176.832 103.195 173.605 101.157 173.605 101.157C173.605 101.157 170.693 103.624 170.832 105.612C171.152 110.189 177.291 109.76 176.971 105.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.762 105.828C167.623 103.84 164.396 101.801 164.396 101.801C164.396 101.801 161.484 104.269 161.623 106.257C161.943 110.834 168.082 110.404 167.762 105.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.179 104.539C186.04 102.552 182.813 100.513 182.813 100.513C182.813 100.513 179.901 102.981 180.04 104.969C180.36 109.546 186.499 109.116 186.179 104.539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.918,
    cy: 71.1989,
    r: 1.53846,
    transform: "rotate(-4 149.918 71.1989)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.738,
    cy: 64.1307,
    r: 0.769231,
    transform: "rotate(-4 151.738 64.1307)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.508 75.2988L184.112 74.9769L184.702 83.4178C184.791 84.6892 183.833 85.7919 182.561 85.8808V85.8808C181.29 85.9698 180.187 85.0112 180.098 83.7398L179.508 75.2988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.438 75.5127L182.577 75.0834L182.792 78.1529C182.911 79.848 181.632 81.3184 179.937 81.4369V81.4369C178.242 81.5555 176.772 80.2773 176.653 78.5821L176.438 75.5127Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10819_8344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.031 120.389C128.474 121.198 141.649 109.335 142.458 93.8924C143.267 78.4497 131.404 65.2747 115.962 64.4654C100.519 63.6561 87.3439 75.5188 86.5346 90.9616C85.7253 106.404 97.588 119.579 113.031 120.389Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.966 83.0908L128.927 84.5562L127.969 102.839C127.907 104.027 126.894 104.939 125.706 104.877L102.046 103.637C100.858 103.575 99.9454 102.561 100.008 101.373L100.966 83.0908Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.984 83.4808L101.022 82.0154C101.022 82.0154 107.451 79.1171 115.172 79.5218C122.894 79.9264 128.984 83.4808 128.984 83.4808Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.59 91.0088L128.815 86.707L132.042 86.8761C132.636 86.9072 133.092 87.414 133.061 88.0079C133.03 88.6019 132.523 89.0581 131.929 89.027L130.854 88.9706L128.59 91.0088Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.628 89.543L100.854 85.2412L97.6272 85.0721C97.0332 85.041 96.5265 85.4973 96.4954 86.0912C96.4642 86.6852 96.9205 87.1919 97.5145 87.223L98.5899 87.2794L100.628 89.543Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.23,
    cy: 78.4462,
    r: 2.15385,
    transform: "rotate(3 115.23 78.4462)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.013 104.653C116.086 103.26 114.018 101.568 114.018 101.568C114.018 101.568 111.784 103.035 111.711 104.428C111.543 107.635 115.845 107.86 116.013 104.653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.56 104.314C109.633 102.921 107.565 101.23 107.565 101.23C107.565 101.23 105.331 102.696 105.258 104.089C105.09 107.296 109.392 107.521 109.56 104.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.465 104.991C122.538 103.598 120.47 101.906 120.47 101.906C120.47 101.906 118.236 103.372 118.163 104.765C117.995 107.973 122.297 108.198 122.465 104.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.117,
    cy: 78.7324,
    r: 1.07692,
    transform: "rotate(3 100.117 78.7324)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.983,
    cy: 73.978,
    r: 0.538462,
    transform: "rotate(3 101.983 73.978)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.324 84.1055L123.551 84.2746L123.241 90.1895C123.194 91.0804 122.434 91.7648 121.543 91.7181V91.7181C120.652 91.6715 119.968 90.9114 120.014 90.0204L120.324 84.1055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.173 83.9922L122.475 84.2176L122.362 86.3685C122.3 87.5564 121.286 88.469 120.098 88.4067V88.4067C118.91 88.3444 117.998 87.331 118.06 86.1431L118.173 83.9922Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 92C66 90.8954 66.8954 90 68 90H88.2654C89.2607 90 90.1046 90.7319 90.2453 91.7172L93.7547 116.283C93.8954 117.268 94.7393 118 95.7346 118H196.265C197.261 118 198.105 117.268 198.245 116.283L201.755 91.7172C201.895 90.7319 202.739 90 203.735 90H224C225.105 90 226 90.8954 226 92V118V144C226 145.105 225.105 146 224 146H194H98H68C66.8954 146 66 145.105 66 144V118V92Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 46.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 10.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.5,
    cy: 129.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 119.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 9.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.5,
    cy: 65.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 38 150)",
    fill: "#24284E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M260 24.5L274.5 19",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M255.5 82L267 84.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 30L29.5 25.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 75L30.5 76.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10819_8344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.791 76.994C208.442 78.8785 194.472 67.9637 192.588 52.615C190.703 37.2663 201.618 23.2959 216.967 21.4114C232.315 19.5268 246.286 30.4416 248.17 45.7903C250.055 61.139 239.14 75.1094 223.791 76.994Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.225 38.9453L205.433 42.3577L207.664 60.5289C207.809 61.7096 208.884 62.5492 210.065 62.4042L233.58 59.5168C234.761 59.3719 235.601 58.2972 235.456 57.1165L233.225 38.9453Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.303 41.289L233.094 37.8766C233.094 37.8766 226.479 35.4338 218.805 36.3761C211.13 37.3184 205.303 41.289 205.303 41.289Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.22 48.7717L205.695 44.4961L202.489 44.8898C201.898 44.9623 201.478 45.4996 201.551 46.09C201.623 46.6803 202.161 47.1001 202.751 47.0276L203.82 46.8964L206.22 48.7717Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.012 45.3586L233.487 41.083L236.694 40.6893C237.284 40.6168 237.822 41.0366 237.894 41.6269C237.967 42.2173 237.547 42.7546 236.956 42.8271L235.888 42.9583L234.012 45.3586Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.15385,
    cy: 2.15385,
    r: 2.15385,
    transform: "matrix(-0.992546 0.121869 0.121869 0.992546 220.548 32.9062)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.719 61.5043C219.549 60.1198 221.494 58.2881 221.494 58.2881C221.494 58.2881 223.825 59.5948 223.995 60.9793C224.386 64.167 220.11 64.692 219.719 61.5043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.133 60.7172C225.963 59.3327 227.908 57.501 227.908 57.501C227.908 57.501 230.239 58.8077 230.409 60.1922C230.8 63.3799 226.524 63.9049 226.133 60.7172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.306 62.2924C213.136 60.9079 215.081 59.0762 215.081 59.0762C215.081 59.0762 217.411 60.3829 217.581 61.7674C217.973 64.9551 213.697 65.4801 213.306 62.2924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.07692,
    cy: 1.07692,
    r: 1.07692,
    transform: "matrix(-0.992546 0.121869 0.121869 0.992546 234.706 33.3379)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.538462,
    cy: 0.538462,
    r: 0.538462,
    transform: "matrix(-0.992546 0.121869 0.121869 0.992546 232.044 29.3252)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.984 41.3076L210.778 41.7013L211.5 47.5803C211.608 48.4658 212.414 49.0955 213.3 48.9868V48.9868C214.185 48.878 214.815 48.072 214.706 47.1865L213.984 41.3076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.122 41.0449L211.846 41.5699L212.109 43.7077C212.254 44.8884 213.329 45.728 214.509 45.583V45.583C215.69 45.438 216.53 44.3634 216.385 43.1827L216.122 41.0449Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_10819_8344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.7002 80.7655C98.0795 79.149 109.236 65.3713 107.62 49.992C106.004 34.6128 92.2259 23.4558 76.8466 25.0722C61.4674 26.6887 50.3104 40.4664 51.9268 55.8456C53.5432 71.2249 67.3209 82.3819 82.7002 80.7655Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9492 45.8145L92.7958 42.8877L94.7095 61.0951C94.8338 62.2781 93.9756 63.3379 92.7926 63.4622L69.2301 65.9388C68.0471 66.0631 66.9872 65.2049 66.8629 64.0219L64.9492 45.8145Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6833 41.8165L64.8367 44.7433C64.8367 44.7433 70.7327 40.8751 78.4223 40.0669C86.112 39.2587 92.6833 41.8165 92.6833 41.8165Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4718 49.3134L93.0215 45.0293L96.2346 44.6916C96.8261 44.6294 97.356 45.0585 97.4181 45.65C97.4803 46.2416 97.0512 46.7715 96.4597 46.8336L95.3887 46.9462L93.4718 49.3134Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6251 52.2401L65.1748 47.9561L61.9617 48.2938C61.3702 48.3559 60.9411 48.8858 61.0033 49.4774C61.0654 50.0689 61.5954 50.498 62.1869 50.4358L63.2579 50.3232L65.6251 52.2401Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.3105,
    cy: 38.996,
    r: 2.15385,
    transform: "rotate(-6 78.3105 38.996)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1837 64.7567C83.0379 63.3695 80.7306 62.0223 80.7306 62.0223C80.7306 62.0223 78.7538 63.8197 78.8996 65.207C79.2353 68.4011 83.5194 67.9508 83.1837 64.7567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7569 65.4325C76.6111 64.0452 74.3038 62.6981 74.3038 62.6981C74.3038 62.6981 72.327 64.4955 72.4728 65.8828C72.8085 69.0768 77.0926 68.6266 76.7569 65.4325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6095 64.0819C89.4637 62.6947 87.1564 61.3475 87.1564 61.3475C87.1564 61.3475 85.1796 63.1449 85.3254 64.5322C85.6611 67.7262 89.9452 67.276 89.6095 64.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.4287,
    cy: 41.642,
    r: 1.07692,
    transform: "rotate(-6 63.4287 41.642)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.5283,
    cy: 36.654,
    r: 0.538462,
    transform: "rotate(-6 64.5283 36.654)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2285 43.7881L87.4416 43.4504L88.0607 49.341C88.154 50.2283 87.5103 51.0231 86.623 51.1164V51.1164C85.7358 51.2097 84.9409 50.566 84.8476 49.6787L84.2285 43.7881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0859 44.0127L86.37 43.5624L86.5952 45.7045C86.7195 46.8875 85.8613 47.9473 84.6783 48.0717V48.0717C83.4952 48.196 82.4354 47.3378 82.3111 46.1547L82.0859 44.0127Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_10819_8344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.247 69.2448C139.429 70.6303 151.238 61.0671 152.624 47.8849C154.009 34.7027 144.446 22.8932 131.264 21.5077C118.082 20.1222 106.272 29.6853 104.887 42.8675C103.501 56.0498 113.064 67.8593 126.247 69.2448Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.593 36.7773L141.461 39.286L139.821 54.8924C139.714 55.9064 138.806 56.642 137.792 56.5354L117.596 54.4127C116.582 54.3061 115.846 53.3977 115.952 52.3837L117.593 36.7773Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.558 38.3682L117.689 35.8595C117.689 35.8595 123.322 33.6671 129.913 34.3598C136.504 35.0526 141.558 38.3682 141.558 38.3682Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.883 44.7951L141.269 41.123L144.023 41.4125C144.53 41.4658 144.897 41.92 144.844 42.427C144.791 42.934 144.337 43.3018 143.83 43.2486L142.912 43.1521L140.883 44.7951Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.014 42.2863L117.4 38.6143L114.646 38.3248C114.139 38.2715 113.685 38.6393 113.632 39.1463C113.579 39.6533 113.946 40.1075 114.453 40.1608L115.371 40.2573L117.014 42.2863Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.009,
    cy: 33.4421,
    r: 1.84615,
    transform: "rotate(6 130.009 33.4421)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.505 55.9098C129.63 54.7207 127.936 53.18 127.936 53.18C127.936 53.18 125.958 54.3347 125.833 55.5238C125.545 58.2616 129.217 58.6475 129.505 55.9098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.996 55.3297C124.121 54.1406 122.427 52.5999 122.427 52.5999C122.427 52.5999 120.449 53.7547 120.324 54.9438C120.036 57.6815 123.709 58.0675 123.996 55.3297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.013 56.4879C135.138 55.2988 133.443 53.7581 133.443 53.7581C133.443 53.7581 131.466 54.9129 131.341 56.102C131.053 58.8397 134.725 59.2257 135.013 56.4879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.061,
    cy: 33.0096,
    r: 0.923077,
    transform: "rotate(6 117.061 33.0096)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.872,
    cy: 29.0229,
    r: 0.461538,
    transform: "rotate(6 118.872 29.0229)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.117 38.5146L136.871 38.8041L136.341 43.8532C136.261 44.6137 135.579 45.1655 134.819 45.0855V45.0855C134.058 45.0056 133.507 44.3243 133.587 43.5638L134.117 38.5146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.281 38.3213L135.953 38.7072L135.76 40.5433C135.654 41.5573 134.745 42.2929 133.731 42.1863V42.1863C132.717 42.0798 131.982 41.1713 132.088 40.1573L132.281 38.3213Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_10819_8344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.283 54.2079C187.506 53.2833 197.475 41.8148 196.55 28.5923C195.626 15.3697 184.157 5.40026 170.935 6.32487C157.712 7.24948 147.743 18.718 148.667 31.9406C149.592 45.1631 161.06 55.1326 174.283 54.2079Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.123 23.7373L184.065 22.0631L185.159 37.7172C185.23 38.7343 184.463 39.6165 183.446 39.6877L163.188 41.1043C162.171 41.1754 161.289 40.4085 161.218 39.3914L160.123 23.7373Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 21.142L160.058 22.8162C160.058 22.8162 165.225 19.6789 171.836 19.2166C178.447 18.7543 184 21.142 184 21.142Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.451 27.5876L184.193 23.9043L186.956 23.7111C187.464 23.6756 187.906 24.059 187.941 24.5676C187.977 25.0761 187.593 25.5172 187.085 25.5528L186.164 25.6172L184.451 27.5876Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.51 29.2614L160.252 25.5781L157.489 25.7713C156.981 25.8069 156.597 26.248 156.633 26.7565C156.669 27.2651 157.11 27.6485 157.618 27.613L158.539 27.5486L160.51 29.2614Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.772,
    cy: 18.2959,
    r: 1.84615,
    transform: "rotate(-4 171.772 18.2959)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.176 40.509C175.093 39.3163 173.156 38.0932 173.156 38.0932C173.156 38.0932 171.409 39.5739 171.493 40.7666C171.685 43.5127 175.368 43.2551 175.176 40.509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.651 40.8957C169.567 39.703 167.631 38.48 167.631 38.48C167.631 38.48 165.884 39.9606 165.967 41.1533C166.159 43.8994 169.843 43.6419 169.651 40.8957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.7 40.1233C180.617 38.9306 178.681 37.7075 178.681 37.7075C178.681 37.7075 176.934 39.1881 177.017 40.3808C177.209 43.127 180.892 42.8694 180.7 40.1233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.944,
    cy: 20.1182,
    r: 0.923077,
    transform: "rotate(-4 158.944 20.1182)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.037,
    cy: 15.8774,
    r: 0.461538,
    transform: "rotate(-4 160.037 15.8774)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.698 22.5781L179.461 22.385L179.815 27.4495C179.868 28.2123 179.293 28.874 178.53 28.9273V28.9273C177.767 28.9807 177.106 28.4055 177.052 27.6427L176.698 22.5781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.856 22.7061L178.54 22.4485L178.669 24.2901C178.74 25.3073 177.973 26.1895 176.956 26.2606V26.2606C175.939 26.3317 175.056 25.5648 174.985 24.5477L174.856 22.7061Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_10819_8344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.611 33.8106C112.381 32.7337 118.618 24.7506 117.541 15.9799C116.465 7.20925 108.482 0.972209 99.7108 2.04911C90.9401 3.12602 84.7031 11.1091 85.78 19.8798C86.8569 28.6505 94.8399 34.8875 103.611 33.8106Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1201 14.0186L109.001 12.0686L110.276 22.4522C110.359 23.1269 109.879 23.741 109.204 23.8238L95.7666 25.4737C95.092 25.5566 94.4779 25.0768 94.3951 24.4021L93.1201 14.0186Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.926 11.4577L93.0453 13.4076C93.0453 13.4076 96.3753 11.1387 100.761 10.6002C105.146 10.0618 108.926 11.4577 108.926 11.4577Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.451 15.7332L109.151 13.29L110.984 13.065C111.321 13.0236 111.628 13.2635 111.67 13.6009C111.711 13.9382 111.471 14.2452 111.134 14.2866L110.523 14.3616L109.451 15.7332Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5705 17.6834L93.2705 15.2402L91.4381 15.4652C91.1008 15.5066 90.8609 15.8137 90.9023 16.151C90.9437 16.4884 91.2508 16.7282 91.5881 16.6868L92.1989 16.6118L93.5705 17.6834Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.686,
    cy: 9.98957,
    r: 1.23077,
    transform: "rotate(-7 100.686 9.98957)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.727 24.6591C103.629 23.8679 102.298 23.1212 102.298 23.1212C102.298 23.1212 101.186 24.1679 101.283 24.959C101.507 26.7806 103.95 26.4806 103.727 24.6591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.063 25.1092C99.9654 24.3181 98.6337 23.5714 98.6337 23.5714C98.6337 23.5714 97.5222 24.6181 97.6194 25.4092C97.843 27.2308 100.286 26.9308 100.063 25.1092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.392 24.2098C107.295 23.4187 105.963 22.672 105.963 22.672C105.963 22.672 104.851 23.7187 104.948 24.5098C105.172 26.3314 107.615 26.0314 107.392 24.2098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.2092,
    cy: 11.6501,
    r: 0.615385,
    transform: "rotate(-7 92.2092 11.6501)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.7882,
    cy: 8.78938,
    r: 0.307692,
    transform: "rotate(-7 92.7882 8.78938)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.114 12.6689L105.947 12.444L106.359 15.8033C106.421 16.3093 106.061 16.7699 105.555 16.832V16.832C105.049 16.8942 104.589 16.5343 104.527 16.0283L104.114 12.6689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.894 12.8184L105.337 12.5184L105.487 13.74C105.57 14.4146 105.09 15.0287 104.415 15.1116V15.1116C103.74 15.1944 103.126 14.7146 103.044 14.04L102.894 12.8184Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10819_8344"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 51,
    width: 80,
    height: 80,
    rx: 40,
    transform: "rotate(-4 130 51)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10819_8344"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 63,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(3 88 63)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10819_8344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    transform: "matrix(-0.992546 0.121869 0.121869 0.992546 244.758 17.999)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_10819_8344"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.999,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-6 49 27.999)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_10819_8344"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.396,
    y: 18.999,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(6 107.396 18.999)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_10819_8344"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.993,
    y: 7.99902,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-4 146.993 7.99902)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_10819_8344"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.8301,
    y: 3.99902,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-7 83.8301 3.99902)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveHealthyCooking);
export default __webpack_public_path__ + "static/media/collective-healthy-cooking.d5f52402fa6a3ec297f74031cd461e07.svg";
export { ForwardRef as ReactComponent };